import { TimeAgo } from '@/components/time-ago';
import { Audience } from '@/models/audiences';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { AudienceNameColumn, ScheduleTypeColumn } from './columns';

const columnHelper = createColumnHelper<Audience>();

export const getAudiencesTableColumns = (t: TFunction) =>
  [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => t('audiences:table.audience_name'),
      cell: ({ row }) => <AudienceNameColumn row={row} />,
      minSize: 550,
      maxSize: 550,
    }),
    columnHelper.accessor('scheduleType', {
      id: 'scheduleType',
      header: () => t('audiences:table.sync'),
      cell: ({ row }) => <ScheduleTypeColumn audience={row.original} />,
      minSize: 130,
      maxSize: 130,
      meta: {
        align: 'center',
      },
    }),
    columnHelper.accessor('createdOn', {
      id: 'createdOn',
      header: () => t('audiences:table.change'),
      cell: ({ getValue }) => <TimeAgo time={getValue()} />,
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
    // columnHelper.display({
    //   id: 'size',
    //   header: () => t('audiences:table.total_users'),
    //   cell: ({ row }) => <AudienceTotalUsersColumn audience={row.original} />,
    //   minSize: 120,
    //   maxSize: 120,
    //   meta: {
    //     className: () => 'font-semibold',
    //     align: 'center',
    //   },
    // }),
  ] as ColumnDef<Audience>[];
